import PropTypes from 'prop-types';

export const propTypes = {
  announcement: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    heroImageFilename: PropTypes.string,
    heroImageContentType: PropTypes.string,
    heroImageUrl: PropTypes.string,
    headline: PropTypes.string,
    copy: PropTypes.string,
    buttonCopy: PropTypes.string,
    buttonLink: PropTypes.string,
    expiryDate: PropTypes.string,
    userGroup: PropTypes.string,
    investorTypes: PropTypes.arrayOf(PropTypes.number),
    companies: PropTypes.arrayOf(PropTypes.number),
    pagesRegex: PropTypes.string,
  }),
  companiesOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })).isRequired,
  investorTypesOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })).isRequired,
};

export const defaultProps = {
  announcement: {
    id: null,
    name: '',
    heroImageFilename: null,
    heroImageContentType: null,
    heroImageUrl: null,
    headline: '',
    copy: '',
    buttonCopy: '',
    buttonLink: '',
    expiryDate: '',
    pagesRegex: '',
    userGroup: '',
    investorTypes: null,
    companies: null,
    userType: 'all',
  },
  companiesOptions: [],
  investorTypesOptions: [],
};
